import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const TYPE_LABELS = {
  add_product: "📦 Add Product",
  update_product: "✏️ Update Product",
  delete_product: "🗑 Delete Product",
  add_sale: "💰 Record Sale",
  add_damaged: "⚠️ Record Damage",
  investor_transaction: "💼 Investor Transaction",
};

export default function PendingApprovals() {
  const [pending, setPending] = useState([]);
  const [reviewNote, setReviewNote] = useState("");
  const [selected, setSelected] = useState(null);

  const fetchData = async () => {
    const res = await axios.get(
      "https://vape-backend-1.onrender.com/api/pending",
    );
    setPending(res.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handle = async (id, action) => {
    try {
      await axios.put(`https://vape-backend-1.onrender.com/api/pending/${id}`, {
        action,
        reviewNote,
      });
      toast.success(action === "approve" ? "✅ Approved!" : "❌ Rejected");
      setSelected(null);
      setReviewNote("");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Pending Approvals</h1>
          <p className="page-subtitle">Review and approve user requests</p>
        </div>
        {pending.length > 0 && (
          <span
            className="badge-status badge-pending"
            style={{ fontSize: "0.85rem", padding: "6px 14px" }}
          >
            {pending.length} pending
          </span>
        )}
      </div>

      {pending.length === 0 ? (
        <div className="card">
          <div className="empty-state">
            <div className="icon">🎉</div>
            <p>No pending requests — all clear!</p>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {pending.map((p) => (
            <div
              key={p._id}
              className="card"
              style={{ border: "1px solid var(--border-accent)" }}
            >
              {/* Header row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 10,
                  marginBottom: 8,
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      fontFamily: "Rajdhani",
                    }}
                  >
                    {TYPE_LABELS[p.type] || p.type}
                  </span>
                  <span className="badge-status badge-pending">Pending</span>
                </div>
                <span
                  style={{ color: "var(--text-muted)", fontSize: "0.76rem" }}
                >
                  {new Date(p.createdAt).toLocaleString("en-BD")}
                </span>
              </div>

              {/* Requested by */}
              <div
                style={{
                  color: "var(--text-secondary)",
                  fontSize: "0.81rem",
                  marginBottom: 10,
                }}
              >
                Requested by:{" "}
                <strong style={{ color: "var(--text-primary)" }}>
                  {p.requestedByName}
                </strong>
              </div>

              {/* Data preview */}
              <div
                style={{
                  background: "var(--bg-primary)",
                  padding: "10px 12px",
                  borderRadius: 8,
                  fontSize: "0.78rem",
                  fontFamily: "monospace",
                  color: "var(--text-secondary)",
                  wordBreak: "break-all",
                  overflowX: "auto",
                  marginBottom: 12,
                  whiteSpace: "pre-wrap",
                  lineHeight: 1.6,
                }}
              >
                {JSON.stringify(p.data, null, 2)
                  .split("\n")
                  .slice(0, 8)
                  .join("\n")}
                {JSON.stringify(p.data, null, 2).split("\n").length > 8 &&
                  "\n..."}
              </div>

              {/* Action buttons — full width on mobile */}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button
                  className="btn btn-success btn-sm"
                  style={{ flex: 1, minWidth: 100 }}
                  onClick={() => handle(p._id, "approve")}
                >
                  ✅ Approve
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  style={{ flex: 1, minWidth: 100 }}
                  onClick={() => setSelected(selected === p._id ? null : p._id)}
                >
                  ❌ Reject
                </button>
              </div>

              {/* Rejection note — expands below */}
              {selected === p._id && (
                <div
                  style={{
                    marginTop: 10,
                    padding: 12,
                    background: "rgba(255,77,109,0.06)",
                    borderRadius: 8,
                    border: "1px solid rgba(255,77,109,0.2)",
                  }}
                >
                  <div className="form-group" style={{ marginBottom: 10 }}>
                    <label>Rejection reason (optional)</label>
                    <input
                      value={reviewNote}
                      onChange={(e) => setReviewNote(e.target.value)}
                      placeholder="Why are you rejecting?"
                      autoFocus
                    />
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      className="btn btn-danger btn-sm"
                      style={{ flex: 1 }}
                      onClick={() => handle(p._id, "reject")}
                    >
                      Confirm Reject
                    </button>
                    <button
                      className="btn btn-ghost btn-sm"
                      style={{ flex: 1 }}
                      onClick={() => {
                        setSelected(null);
                        setReviewNote("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
